<script setup lang="ts">
// Material Symbols `gpp_maybe` — shield with an exclamation, the design's marker
// for an amber needs-attention surface (Figma 20779:5800). The exported glyph is
// drawn on a 16×20 box inside the 24×24 icon frame, so it is offset here rather
// than re-scaled; that keeps its optical weight matched to the other 24px icons
// beside it.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
    <g transform="translate(4 2)">
      <path
        d="M8.7125 13.7125C8.90416 13.5208 9 13.2833 9 13C9 12.7167 8.90416 12.4792 8.7125 12.2875C8.52084 12.0958 8.28334 12 8 12C7.71666 12 7.47916 12.0958 7.2875 12.2875C7.09584 12.4792 7 12.7167 7 13C7 13.2833 7.09584 13.5208 7.2875 13.7125C7.47916 13.9042 7.71666 14 8 14C8.28334 14 8.52084 13.9042 8.7125 13.7125ZM7 10H9V5H7V10ZM8 20C5.68334 19.4166 3.77084 18.0876 2.2625 16.0125C0.75416 13.9375 0 11.6333 0 9.1V3L8 0L16 3V9.1C16 11.6333 15.2458 13.9375 13.7375 16.0125C12.2292 18.0876 10.3167 19.4166 8 20ZM8 17.9C9.73334 17.35 11.1667 16.25 12.3 14.6C13.4333 12.95 14 11.1167 14 9.1V4.375L8 2.125L2 4.375V9.1C2 11.1167 2.56666 12.95 3.7 14.6C4.83334 16.25 6.26666 17.35 8 17.9Z"
      />
    </g>
  </svg>
</template>
